<template>
  <div class="bg-warning-soft py-4 px-4 md:px-8">
    <header class="mb-2">
      <h4 v-if="title" class="text-xl font-bold">{{ title }}</h4>
      <p class="text-sm text-red-700 mt-1"><strong>Importante:</strong> Si revoca el consentimiento se eliminaran todos los datos de su identidad biométrica del sistema. Para volver a habilitar su uso deberá realizar nuevamente el proceso.</p>
    </header>
    <div class="rounded-lg bg-white flex flex-col md:flex-row items-center justify-between p-2 mt-4 shadow">
      <div class="flex items-center space-x-2 w-full overflow-hidden py-2 md:py-0 justify-center md:justify-start">
        <img src="@/assets/img/faceOk.svg" class="pl-1 pr-2" />
        <p class="truncate">Acceso biométrico <strong class="text-green-600">Habilitado</strong></p>
      </div>
      <el-button @click="revoke" type="danger" class="w-full md:w-auto flex-shrink-0">Revocar</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BiometricAccessEnabled',
  props: {
    title: {
      type: String,
      required: false
    }
  },
  methods: {
    revoke: function () {
      this.$emit('revoke')
    }
  }
}
</script>
